import {styled} from "@mui/material/styles"
import {FALLBACK_FONT_FAMILY} from "@next/ux-fabric"

export const MiniShoppingBagContainer = styled("div")`
    color: ${({theme}) => `${theme.uxfabric.text.primary}`};
    display: flex;
    flex-direction: column;
    border-radius: 0.25rem;
    background-color: ${({theme}) => theme.uxfabric.components.dialog.dialogContent.default.backgroundColor};
`
export const PriceWrapperItem = styled("div")`
    display: flex;
    justify-content: space-between;
    padding: 0.5rem 1rem;
    font-family: ${({theme}) => `${theme.uxfabric.global.body3.fontFamily}, ${FALLBACK_FONT_FAMILY}`} !important;
    font-size: ${({theme}) => `${theme.uxfabric.global.body3.fontSize}`};
    font-weight: ${({theme}) => `${theme.uxfabric.global.body3.fontWeight}`};
    line-height: ${({theme}) => `${theme.uxfabric.global.body3.lineHeight}`};
    letter-spacing: ${({theme}) => `${theme.uxfabric.global.body3.letterSpacing}px`};
    color: ${({theme}) => `${theme.uxfabric.text.primary}`};
`

export const TotalText = styled("div")`
    font-family: ${({theme}) => `${theme.uxfabric.global.body3.fontFamily}, ${FALLBACK_FONT_FAMILY}`} !important;
    font-weight: ${({theme}) => `${theme.uxfabric.global.body3.fontWeight}`};
`

export const PromotionWrapper = styled("div")`
    display: flex;
    justify-content: space-between;
    padding: 0.5rem 1rem 0rem 1rem;
    color: ${({theme}) => theme.uxfabric.brand.success};
    background: ${({theme}) => theme.uxfabric.components.dialog.dialogActions.default.backgroundColor};
    font-size: 0.875rem;
    &:nth-of-type(2) {
        padding: 1rem 1rem 0rem 1rem;
    }
    &:nth-child(3) {
        border-top: unset;
    }
    border: 0.0625rem solid ${({theme}) => theme.uxfabric.components.dialog.dialogActions.default.borderColor};
    border-bottom: unset;
`

export const PromotionDiscount = styled("div")`
    font-family: ${({theme}) => `${theme.uxfabric.global.body3.fontFamily}, ${FALLBACK_FONT_FAMILY}`} !important;
    font-size: ${({theme}) => `${theme.uxfabric.global.body3.fontSize}`};
    line-height: ${({theme}) => `${theme.uxfabric.global.body3.lineHeight}`};
    letter-spacing: ${({theme}) => `${theme.uxfabric.global.body3.letterSpacing}`};
    font-weight: ${({theme}) => `${theme.uxfabric.global.body3.fontWeight}`};
    color: ${({theme}) => `${theme.uxfabric.brand.success.default.textColor}`};
`
export const PromotionText = styled("div")`
    font-family: ${({theme}) => `${theme.uxfabric.global.body3.fontFamily}, ${FALLBACK_FONT_FAMILY}`} !important;
    font-size: ${({theme}) => `${theme.uxfabric.global.body3.fontSize}`};
    line-height: ${({theme}) => `${theme.uxfabric.global.body3.lineHeight}`};
    letter-spacing: ${({theme}) => `${theme.uxfabric.global.body3.letterSpacing}`};
    text-transform: ${({theme}) => `${theme.uxfabric.global.body3.textTransform}`};
    font-weight: ${({theme}) => `${theme.uxfabric.global.body3.fontWeight}`};
    color: ${({theme}) => `${theme.uxfabric.brand.success.default.textColor}`};
`

export const StandardDeliveryContainer = styled("div")`
    font-size: ${({theme}) => `${theme.uxfabric.global.body2.fontSize}`};
    font-weight: ${({theme}) => `${theme.uxfabric.global.body2.fontWeight}`};
    text-transform: ${({theme}) => `${theme.uxfabric.global.body2.textTransform}`};
    padding: 0 1rem 0.5rem 1.125rem;
    border-bottom: ${({theme}) => theme.uxfabric.components.dialog.dialogHeader.default.borderBottomColor};
    && > p {
        font-size: ${({theme}) => `${theme.uxfabric.global.body2.fontSize}`};
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: 0.0075rem;
        word-break: break-all;
    }
`
export const Block = styled("span")`
    display: block;
`

export const ItemsContainer = styled("div")`
    min-width: 100%;
    overflow-y: auto;

    > div:first-of-type {
        border-top: 0;
    }
    > div {
        border-top: 0.0625rem solid ${({theme}) => theme.uxfabric.components.divider.default.borderColor};
    }
    > div:last-of-type {
        border-bottom: 0;
    }
    -ms-overflow-style: auto;
    scrollbar-width: auto;
    &::-webkit-scrollbar {
        -webkit-appearance: none;
        width: 0.475rem;
    }

    &::-webkit-scrollbar-thumb {
        border-radius: 0.25rem;
        background-color: rgba(0, 0, 0, 0.5);
        box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
    }

    max-width: 19.875rem;
    max-height: 14.6875rem;

    border-width: 0 0.0625rem;
    border-style: solid;
    border-color: ${({theme}) => theme.uxfabric.components.dialog.dialogContent.default.borderColor};
    background-color: ${({theme}) => theme.uxfabric.components.dialog.dialogContent.default.backgroundColor};
    margin: 0;
`

type ContainerProps = {
    isFirstSection: boolean
}

export const StyledActionsContainer = styled("div", {
    shouldForwardProp: prop => prop !== "isFirstSection",
})<ContainerProps>`
    background: ${({theme}) => theme.uxfabric.components.dialog.dialogActions.default.backgroundColor};
    border: 0.0625rem solid ${({theme}) => theme.uxfabric.components.dialog.dialogActions.default.borderColor};
    border-bottom: unset;
    border-top: ${({theme: {uxfabric}, isFirstSection}) =>
        isFirstSection ? `0.0625rem solid ${uxfabric.components.dialog.dialogActions.default.borderColor}` : "unset"};
`
